import { gql } from '@apollo/client';

const EDIT_FINDINGS = gql`
  mutation editFindings($id: ID!, $reportFindings: String!, $signature: String) {
    editFindings(id: $id, reportFindings: $reportFindings, signature: $signature) {
      isSuccess
      message
    }
  }
`;

export default EDIT_FINDINGS;
